// 配置编译环境和线上环境之间的切换

let baseUrl = ''
const iconfontVersion = ['834741_xhwgnrth3p']
const iconfontUrl = `//at.alicdn.com/t/font_$key.css`
const codeUrl = `${baseUrl}/code`
const env = process.env
// 各平台标题配置项
const COMPANYNAMES = {
  zlkj: '湖南中澜信息科技有限公司',
  gmcx: '黑龙江省畅途科技有限公司'
}
// 当前平台
const PLATFORM = 'gmcx'
// 当前平台所属公司
const COMPANYNAME = COMPANYNAMES[PLATFORM]
if (env.NODE_ENV === 'development') {
  baseUrl = `` // 开发环境地址
} else if (env.NODE_ENV === 'production') {
  baseUrl = `` // 生产环境地址
} else if (env.NODE_ENV === 'test') {
  baseUrl = `` // 测试环境地址
}
export {
  PLATFORM,
  COMPANYNAME,
  baseUrl,
  iconfontUrl,
  iconfontVersion,
  codeUrl,
  env
}



// WEBPACK FOOTER //
// ./src/config/env.js